import React from 'react';
import { MOCK_UP } from '../../../propTypes';
import { Composition } from '../Composition';
import { isTransparent } from '../../../lib/color';
import { cupMockUp } from './landscapeConfig';
import { cupMockUpSquare } from './squareConfig';

export const CupMockUp = ({ variation, className, isSquare = false }) => {
    const mockUpConfig = { ...(isSquare ? cupMockUpSquare : cupMockUp) };

    if (isTransparent(variation.backgroundColor)) {
        const [baseImageLayer, gradientLayer, ...restOfCupLayers] = mockUpConfig.layers;
        mockUpConfig.layers = [gradientLayer, baseImageLayer, ...restOfCupLayers];
    }

    return (
        <Composition
            className={className}
            variation={variation}
            layers={mockUpConfig.layers}
            aspectRatio={mockUpConfig.aspectRatio}
            transparentBackground={true}
        />
    );
};

CupMockUp.propTypes = MOCK_UP;
